"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sellano": {
    "c11e3c7c": [{
      "hkey": "aa7394f2",
      "slug": "molini",
      "name": "Molini",
      "primary": true,
      "skipSearch": false
    }],
    "molini-di-cammoro": [{
      "hkey": "aa7394f2",
      "slug": "molini",
      "name": "Molini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2c373137": [{
      "hkey": "53a1535b",
      "slug": "sellano",
      "name": "Sellano",
      "primary": true,
      "skipSearch": false
    }],
    "orsano": [{
      "hkey": "53a1535b",
      "slug": "sellano",
      "name": "Sellano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a3c748b1": [{
      "hkey": "cca3859e",
      "slug": "postignano-colle",
      "name": "Postignano-Colle",
      "primary": true,
      "skipSearch": false
    }],
    "postignano": [{
      "hkey": "cca3859e",
      "slug": "postignano-colle",
      "name": "Postignano-Colle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "055e1bc7": [{
      "hkey": "24a154f8",
      "slug": "villamagina",
      "name": "Villamagina",
      "primary": true,
      "skipSearch": false
    }],
    "villamaggina": [{
      "hkey": "24a154f8",
      "slug": "villamagina",
      "name": "Villamagina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;